import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../../core/common';
import { IGetSampleProductOrderHeader, ISampleProductOrderHeader, ISampleProductOrderDetails, IGetSampleProductOrderDetailsByHeader, IDiscountStoreOrderHeader, IDiscountStoreOrderDetails } from '../../../../../../core/models';
import { ProductSampleFulfillmentService } from '../../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotifyType } from '../../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../../core/services/app-notify.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CommonService } from '../../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";
import { DiscountStoreService } from '../../../../../../core/services/discount-store.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  orderDetailsGridData: GridDataResult;
  orderDetails: any[] = [];
  orderLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  orderNum: number = 0;
  order: any;
  orderHeader: IDiscountStoreOrderHeader;
  userEmail: string = '';
  orderTotal: number = 0;
  orderGridDetails: IDiscountStoreOrderDetails = {
    discountStoreRequestHeaderId: 'test',
    categoryId: 1,
    subCategoryId: 1,
    categoryName: 'Discount Category 1',
    subCategoryDescription: 'Discount Description1',
    colorCode: '',
    stockNum: '1234',
    quantity: '5',
    createdDate: undefined,
    sampleProductOrderNumber: '',
    cost: '100',
    sampleProductUniqueId: 1
  };

  protected orderLblText = {
    orderNumberLbl: 'Order Number',
    contactLbl: 'Contact',
    customerLbl: 'Customer',
    ccEmailLbl: 'CC Email(s)',
    regionLbl: 'Region',
    createdDateLbl: 'Order Date',
    sampleProductOrderNumberLbl: 'Order Number',
    costLbl: 'Order Cost',
    trackingMethodLbl: 'Tracking Method',
    trackingNumberLbl: 'Tracking Number',
    contactEmailLbl: 'Contact Email',
  };
  protected orderDetailsLblText = {
    stockNumLbl: 'Stock #',
    productDescriptionLbl: 'Product Description',
    quantityLbl: 'Quantity',
    costLbl: 'Cost',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Product',
    orderSummaryLbl: 'Order Summary'
  };
  constructor(private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService,
    private commonService: CommonService,
    private cp: CurrencyPipe,
    private discountStoreService: DiscountStoreService,
    private location: Location
  ) {
    this.route.params.subscribe((params: Params) => {
      this.orderNum = params['orderId'] || 'ttt';
      console.log(this.orderNum);
    });
  }
  updateInProcess: boolean = false;
  async ngOnInit() {
    this.order = await this.discountStoreService.getOrderDetails(this.orderNum).toPromise();
    console.log(this.order);
    if (!this.order) {
      this.router.navigate(['home']);
    } else {
      //this.getOrderDetails();
    }

    this.orderHeader = this.order.header;
    this.orderDetails = this.order.detail;
    if (this.orderHeader.statusId == 1) {
      this.shouldBeReadOnly = false;
    }
    else {
      this.shouldBeReadOnly = true;
      this.processingComment = this.orderHeader.processingComments;
      this.salesOrderNumbers = this.orderHeader.salesOrderNumbers;
      this.numberOfSalesOrder = this.orderHeader.numberOfSalesOrder;
      this.orderCompletedBy = this.orderHeader.orderCompletedBy;
    }

    this.orderDetails.forEach((el, index) => {
      el["extendedPrice"] = el.salePrice * el.quantity;
      this.orderTotal += el["extendedPrice"];
    })
    this.bindOrderDetailsGridData();
    //this.orderHeader.status=='not complete' then readonly flaog wiil be true
  }
  public orderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'longItemNumber',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public orderGridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.orderDetails, this.orderGridstate),
    columnsConfig: [{
      field: 'quantity',
      title: 'Quantity',//this.orderDetailsLblText.stockNumLbl,
      filterable: true,
      widthForPDF: 120,
      _width: 120,
    },
    {
      field: 'longItemNumber',
      title: 'Long Item Number',//this.orderDetailsLblText.productDescriptionLbl,
      filterable: true,
      widthForPDF: 150,
      _width: 180,
    },
    {
      field: 'availableLocName',
    title: 'Location',
    filterable: true,
    widthForPDF: 100,
    _width: 160,
    },
    {
      field: 'salePrice',
      title: 'Unit Price',//this.orderDetailsLblText.costLbl,
      filterable: true,
      widthForPDF: 100,
      _width: 120,
    }, {
      field: 'extendedPrice',
      title: 'Extended Price',//this.orderDetailsLblText.costLbl,
      filterable: true,
      widthForPDF: 100,
      _width: 120,
    }
    ]
  };

  private bindOrderDetailsGridData(): void {
    if (this.orderGridSettings.state)
      this.orderDetailsGridData = process(this.orderDetails, this.orderGridSettings.state);
    else
      this.orderDetailsGridData = process(this.orderDetails, this.orderGridstate);
    this.orderGridSettings.gridData = this.orderDetailsGridData;
  }
  protected orderDetailsGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.bindOrderDetailsGridData();
  }

  protected orderDetailsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.bindOrderDetailsGridData();
  }

  public orderDetailsGridDataStateChange(state: DataStateChangeEvent): void {
    this.orderGridstate = state;
    this.orderGridSettings.state = this.orderGridstate;
    this.bindOrderDetailsGridData();
  }



  redirectToOrderHistoryPage() {
    this.location.back();
  }
  processedBy: string;
  processingComment: string;
  salesOrderNumbers: string;
  numberOfSalesOrder: string;
  orderCompletedBy: string;
  async completeOrder() {
    var data = {};
    data["orderHeaderId"] = this.orderHeader.orderHeaderId;
    data["numberOfSalesOrder"] = this.numberOfSalesOrder;
    data["salesOrderNumbers"] = this.salesOrderNumbers || '';
    data["processingComments"] = this.processingComment || '';
    data["processedBy"] = this.userService.readUserObject.userId;
    this.updateInProcess = true;
    const resp = await this.discountStoreService.completeOrder(data).toPromise();
    if (resp == 'error') { }
    else {
      //success
      this.order = await this.discountStoreService.getOrderDetails(this.orderNum).toPromise();
      this.orderHeader = this.order.header;
      this.orderCompletedBy = this.orderHeader.orderCompletedBy;
      this.shouldBeReadOnly = true;
    }
    this.updateInProcess = false;
  }

  shouldBeReadOnly: boolean = false;
}
